import { render, staticRenderFns } from "./detail_summary.vue?vue&type=template&id=6a3096ca&scoped=true&"
import script from "./detail_summary.vue?vue&type=script&lang=js&"
export * from "./detail_summary.vue?vue&type=script&lang=js&"
import style0 from "./detail_summary.vue?vue&type=style&index=0&id=6a3096ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3096ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3096ca')) {
      api.createRecord('6a3096ca', component.options)
    } else {
      api.reload('6a3096ca', component.options)
    }
    module.hot.accept("./detail_summary.vue?vue&type=template&id=6a3096ca&scoped=true&", function () {
      api.rerender('6a3096ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_related_information_report/visitDetail/components/detail_summary.vue"
export default component.exports